import React, { useState, useEffect, useCallback } from 'react';
import { CircularProgress } from '@material-ui/core';
import { fTimeDateUSFormat } from '@/actions/Helper';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';
import LoadingV2 from '@/components/Loading';
import Modal from '@/ctComponents/Modal';
import styles from './styles';
import { useNotify } from 'react-admin';
import { SaveApiResMessage } from '@/actions';
import HintLegend, {
  getHintLegendByOriginStatus,
  HintLegendItem,
} from '@/components/HintLegend';
import IconButtonV2 from '@/ctComponents/IconButton/IconButtonV2';
import CustomCheckbox from '@/components/CustomCheckbox';
import Tooltip from '@/components/Tooltip';

const AppointmentIcon = React.memo(({ appointment, index }) => {
  if (!appointment) return null;

  const isUsed = appointment.status === 'USED';
  const margin = isUsed ? '-10px' : 'unset';
  const src = isUsed ? Icons.tickAppointment : Icons.hidden;

  return <ReactSVG style={{ margin }} src={src} />;
});

const AppointmentContainer = React.memo(
  ({ container, cls, Appointment, i }) => {
    if (!container?.appointments?.length) return null;

    const firstAppointment = container.appointments[0];
    const secondAppointment = container.appointments[1];

    return (
      <button
        type="button"
        className={`${cls.butReturnApt} `}
        style={{
          border:
            container.autobook_from > 0
              ? '1px solid #1FC16B'
              : '1px solid #a2a2a2',
        }}>
        {container.autobook_on === 1 && (
          <span
            style={{
              borderTopLeftRadius: '0px',
              borderBottomLeftRadius: '0px',
            }}
            className="absolute top-0 rounded right-0 flex w-2 justify-center items-center bg-success-secondary text-white h-full">
            <span
              style={{
                marginRight: '-1px',
              }}
              className=" text-8  rotate-90 flex justify-center items-center">
              Autobook
            </span>
          </span>
        )}
        <div className={cls.appointmentContainer}>
          <div className={cls.appointmentDateContainer}>
            <span>
              <AppointmentIcon appointment={firstAppointment} index={0} />
            </span>
            <span className="flex flex-row items-center gap-1 justify-between">
              <span
                className="flex flex-row items-center gap-1 h-2 w-36 justify-between"
                style={{
                  width: '128px',
                }}>
                <span className={cls.appointmentDateContainerDates}>
                  {firstAppointment?.terminal_appointment_availability?.date?.replace(
                    /(\d{4})-(\d{2})-(\d{2})/,
                    '$2-$3-$1'
                  )}
                </span>
                <span className={cls.appointmentDateContainerTimes}>
                  {' '}
                  {`(${firstAppointment?.terminal_appointment_availability?.time_start?.replace(
                    /\s?(AM|PM)/gi,
                    ''
                  )}-${firstAppointment?.terminal_appointment_availability?.time_end?.replace(
                    /\s?(AM|PM)/gi,
                    ''
                  )})`}
                </span>
              </span>
              <span className="border-r pr-1 border-solid border-b-0 border-l-0 border-t-0 border-border-tertiary">
                <HintLegendItem
                  isSmall
                  hint={getHintLegendByOriginStatus(
                    firstAppointment?.origin_source
                  )}
                />
              </span>
            </span>
            <span
              className={`${cls.appointmenTerminal} w-24 ${
                container?.autobook_on === 1 ? 'pr-4' : ''
              }`}>
              {firstAppointment?.terminal_appointment_availability?.terminal
                ?.slug || firstAppointment?.terminal?.slug}
            </span>{' '}
          </div>
          {secondAppointment && (
            <div className={`${cls.appointmentDateContainer} mt-02`}>
              <span>
                <AppointmentIcon appointment={secondAppointment} index={1} />
              </span>
              <span className="flex flex-row items-center gap-1 h-2 justify-between">
                <span
                  className="flex flex-row items-center gap-1 h-2 w-36 justify-between"
                  style={{
                    width: '128px',
                  }}>
                  <span className={cls.appointmentDateContainerDates}>
                    {secondAppointment?.terminal_appointment_availability?.date?.replace(
                      /(\d{4})-(\d{2})-(\d{2})/,
                      '$2-$3-$1'
                    )}
                  </span>
                  <span className={cls.appointmentDateContainerTimes}>
                    {' '}
                    {`(${secondAppointment?.terminal_appointment_availability?.time_start?.replace(
                      /\s?(AM|PM)/gi,
                      ''
                    )}-${secondAppointment?.terminal_appointment_availability?.time_end?.replace(
                      /\s?(AM|PM)/gi,
                      ''
                    )})`}
                  </span>
                </span>
                <span className="border-r pr-1 border-solid border-b-0 border-l-0 border-t-0 border-border-tertiary">
                  <HintLegendItem
                    isSmall
                    hint={getHintLegendByOriginStatus(
                      secondAppointment?.origin_source
                    )}
                  />
                </span>
              </span>
              <span
                className={`${cls.appointmenTerminal} w-24 ${
                  container?.autobook_on === 1 ? 'pr-4' : ''
                }`}>
                {secondAppointment?.terminal?.slug}
              </span>{' '}
            </div>
          )}
          {container?.appointments?.length > 2 && (
            <div
              className={cls.moreAppointments}
              style={{
                fontSize: '9px',
                color: '#335CFF',
                fontFamily: 'Averta',
                padding: '0px',
                lineHeight: '9px',
              }}>
              +{container?.appointments?.length - 2} more
            </div>
          )}
        </div>
      </button>
    );
  }
);

const TableDroppedList = ({
  cls,
  tableRef,
  amirbios2Ref,
  amirbios1Ref,
  tableTheadTitle,
  containersData,
  currentPage,
  uniqueIndex,
  formatDateTimeToUTC,
  formatDateToUTC,
  formatPrice,
  fDate,
  fTimeDate,
  enable_appointments,
  Appointment,
  shareLink,
  handleGetShareLink,
  Edit,
  DelContainer,
  handleChangeContainerStatus,
  timerinterval,
  fastProgress,
  getActivContainers,
  showContainersModal,
  setShowContainersModal,
  setSelectedRow,
  Del,
  mptyTrackingEnable,
  activeTab,
}) => {
  const notify = useNotify();
  let localUniqueIndex = uniqueIndex;

  // Sorting state
  const [sortConfig, setSortConfig] = useState(() => {
    // Load sort state from localStorage on component mount
    const savedSort = localStorage.getItem('inventoryDroppedTableSort');
    if (savedSort) {
      try {
        return JSON.parse(savedSort);
      } catch (error) {
        console.error('Error parsing saved sort state:', error);
        return { key: null, direction: '' };
      }
    }
    return { key: null, direction: '' };
  });
  const [sortedData, setSortedData] = useState([]);
  const [hoveredColumn, setHoveredColumn] = useState(null);

  // Delete confirmation modal state
  const [showDeleteModal, setShowDeleteModal] = useState({
    show: false,
    itemId: null,
    deleteType: null, // 'container' or 'inventory'
  });

  // Handle container name click - copy to clipboard and open link after 2 seconds
  const handleContainerNameClick = useCallback((e, container, objectKey) => {
    e.preventDefault();
    const containerNumber = container[objectKey] || '-';
    const trackingUrl = container['shipping_line_tracking_url'];

    // Copy container number to clipboard
    navigator.clipboard
      .writeText(containerNumber)
      .then((res) => {
        // Show notification
        // notify(`Container Number "${containerNumber}" Copied`, 'success');
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: `Container Number "${containerNumber}" Copied`,
          mode: 'success',
        });

        // Open link in new tab after 2 seconds
        setTimeout(() => {
          window.open(trackingUrl, '_blank');
        }, 1000);
      })
      .catch((err) => {
        // Fallback if clipboard API fails
        // notify(`Container Number "${containerNumber}" Copied`, 'success');
        SaveApiResMessage({
          title: 'error',
          message: `Container Number "${containerNumber}" Not Copied`,
          mode: 'success',
        });
        setTimeout(() => {
          window.open(trackingUrl, '_blank');
        }, 1000);
      });
  }, []);

  // Handle delete confirmation
  const handleDeleteConfirm = useCallback(() => {
    if (showDeleteModal.itemId && showDeleteModal.deleteType) {
      if (showDeleteModal.deleteType === 'container') {
        DelContainer(showDeleteModal.itemId);
      } else if (showDeleteModal.deleteType === 'inventory') {
        Del(showDeleteModal.itemId);
      }
      setShowDeleteModal({ show: false, itemId: null, deleteType: null });
    }
  }, [showDeleteModal.itemId, showDeleteModal.deleteType, DelContainer, Del]);

  // Handle delete button click - show confirmation modal
  const handleDeleteClick = useCallback((itemId, deleteType) => {
    setShowDeleteModal({ show: true, itemId, deleteType });
  }, []);

  // Sortable columns configuration
  const sortableColumns = {
    size: 'size',
    ssl: 'ssl',
    loc: 'loc',
    name: 'name',
    single_transaction: 'single_transaction',
    last_update: 'updated_at',
    chassis_type: 'chassis_type',
    last_free_day: 'last_free_day',
    est_per_diem: 'est_per_diem',
    gated_in: 'gated_in',
    gated_out: 'gated_out',
    last_import: 'added_date',
    return_appointment: 'return_appointment',
  };

  // Sort function
  const sortBy = (key) => {
    console.log('=== SORT BY CALLED ===');
    console.log('Key:', key);
    console.log('Current sortConfig:', sortConfig);

    let newSortConfig;

    // Three-state sorting: ascending -> descending -> no sort
    if (sortConfig.key === key) {
      // If clicking the same column, cycle through states
      if (sortConfig.direction === 'ascending') {
        // Current: ascending -> Next: descending
        newSortConfig = { key, direction: 'descending' };
      } else if (sortConfig.direction === 'descending') {
        // Current: descending -> Next: no sort (clear)
        newSortConfig = { key: null, direction: '' };
      }
    } else {
      // If clicking a different column, start with ascending
      newSortConfig = { key, direction: 'ascending' };
    }

    // Update state
    setSortConfig(newSortConfig);

    // Save to localStorage
    localStorage.setItem(
      'inventoryDroppedTableSort',
      JSON.stringify(newSortConfig)
    );
  };

  // Sort data when sortConfig changes
  useEffect(() => {
    if (!containersData) return;

    if (sortConfig.key && sortConfig.direction) {
      const sorted = [...containersData].sort((a, b) => {
        let aValue, bValue;

        // Handle different data structures
        if (a?.containers) {
          // First table structure - use parent data for some fields, container data for others
          if (['size', 'ssl', 'loc'].includes(sortConfig.key)) {
            aValue = a[sortConfig.key];
          } else {
            // For container-specific fields (including name), we need to access the first container
            aValue = a.containers?.[0]?.[sortConfig.key];
          }
        } else {
          // Second table structure - use direct data
          aValue = a[sortConfig.key];
        }

        if (b?.containers) {
          // First table structure - use parent data for some fields, container data for others
          if (['size', 'ssl', 'loc'].includes(sortConfig.key)) {
            bValue = b[sortConfig.key];
          } else {
            // For container-specific fields (including name), we need to access the first container
            bValue = b.containers?.[0]?.[sortConfig.key];
          }
        } else {
          // Second table structure - use direct data
          bValue = b[sortConfig.key];
        }

        // Handle null/undefined values
        if (aValue === null || aValue === undefined) aValue = '';
        if (bValue === null || bValue === undefined) bValue = '';

        // Special handling for different data types
        if (
          sortConfig.key === 'updated_at' ||
          sortConfig.key === 'last_free_day' ||
          sortConfig.key === 'gated_in' ||
          sortConfig.key === 'gated_out' ||
          sortConfig.key === 'added_date'
        ) {
          // Date sorting for "last update", "LFD (Last Free Day)", "Gated In", "Gated Out", and "Last Import"
          const aDate = aValue ? new Date(aValue) : new Date(0);
          const bDate = bValue ? new Date(bValue) : new Date(0);

          // Handle invalid dates
          const aTime = isNaN(aDate.getTime()) ? 0 : aDate.getTime();
          const bTime = isNaN(bDate.getTime()) ? 0 : bDate.getTime();

          if (sortConfig.direction === 'ascending') {
            return aTime - bTime;
          } else {
            return bTime - aTime;
          }
        } else if (sortConfig.key === 'return_appointment') {
          // Handle return_appointment - check both direct property and appointments array
          // For TableDroppedList, data structure is: inventories.data[].containers[].appointments[]
          aValue =
            a?.containers?.[0]?.appointments?.[0]
              ?.terminal_appointment_availability?.date ||
            a?.containers?.[0]?.return_appointment ||
            a?.appointments?.[0]?.terminal_appointment_availability?.date ||
            a?.return_appointment ||
            '';
          bValue =
            b?.containers?.[0]?.appointments?.[0]
              ?.terminal_appointment_availability?.date ||
            b?.containers?.[0]?.return_appointment ||
            b?.appointments?.[0]?.terminal_appointment_availability?.date ||
            b?.return_appointment ||
            '';

          // Special logic for return_appointment: items with dates first, then items without dates
          const aHasDate =
            aValue &&
            aValue !== '' &&
            aValue !== 'null' &&
            aValue !== 'undefined';
          const bHasDate =
            bValue &&
            bValue !== '' &&
            bValue !== 'null' &&
            bValue !== 'undefined';

          // Always prioritize items with dates over items without dates
          if (aHasDate && !bHasDate) {
            return -1; // a comes first (items with dates always go first)
          }
          if (!aHasDate && bHasDate) {
            return 1; // b comes first (items with dates always go first)
          }

          // If both have dates, sort by date
          if (aHasDate && bHasDate) {
            // Convert dates to comparable format (YYYY-MM-DD)
            const normalizeDate = (dateStr) => {
              if (!dateStr) return '0000-00-00';

              // First, try to extract date from complex format like "09 22 2025 (18:00-20:00) SSA MARINE"
              const complexDateMatch = dateStr.match(
                /^(\d{1,2})\s+(\d{1,2})\s+(\d{4})\s*\(/
              );
              if (complexDateMatch) {
                const [, month, day, year] = complexDateMatch;
                return `${year}-${month.padStart(2, '0')}-${day.padStart(
                  2,
                  '0'
                )}`;
              }

              // Handle YYYY-MM-DD format (already normalized)
              if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(dateStr)) {
                return dateStr;
              }

              // Handle MM-DD-YYYY format (like 09-19-2025)
              const mmddyyyyMatch = dateStr.match(
                /^(\d{1,2})-(\d{1,2})-(\d{4})$/
              );
              if (mmddyyyyMatch) {
                const [, month, day, year] = mmddyyyyMatch;
                return `${year}-${month.padStart(2, '0')}-${day.padStart(
                  2,
                  '0'
                )}`;
              }

              // Handle MM/DD/YYYY format
              const mmddyyyySlashMatch = dateStr.match(
                /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/
              );
              if (mmddyyyySlashMatch) {
                const [, month, day, year] = mmddyyyySlashMatch;
                return `${year}-${month.padStart(2, '0')}-${day.padStart(
                  2,
                  '0'
                )}`;
              }

              // Handle MM DD YYYY format (space separated)
              const mmddyyyySpaceMatch = dateStr.match(
                /^(\d{1,2})\s+(\d{1,2})\s+(\d{4})$/
              );
              if (mmddyyyySpaceMatch) {
                const [, month, day, year] = mmddyyyySpaceMatch;
                return `${year}-${month.padStart(2, '0')}-${day.padStart(
                  2,
                  '0'
                )}`;
              }

              // Fallback to original string
              return dateStr;
            };

            const aNormalized = normalizeDate(String(aValue));
            const bNormalized = normalizeDate(String(bValue));

            if (sortConfig.direction === 'ascending') {
              return aNormalized.localeCompare(bNormalized); // Oldest first (ascending)
            } else {
              return bNormalized.localeCompare(aNormalized); // Newest first (descending)
            }
          } else {
            // If neither has dates, maintain original order
            return 0;
          }
        } else if (sortConfig.key === 'est_per_diem') {
          // Number sorting for "Est. PerDiem" - extract numeric value from currency string
          const aNum = aValue
            ? parseFloat(String(aValue).replace(/[^0-9.-]/g, '')) || 0
            : 0;
          const bNum = bValue
            ? parseFloat(String(bValue).replace(/[^0-9.-]/g, '')) || 0
            : 0;

          if (sortConfig.direction === 'ascending') {
            return aNum - bNum;
          } else {
            return bNum - aNum;
          }
        } else {
          // String sorting for other columns
          aValue = String(aValue).toLowerCase();
          bValue = String(bValue).toLowerCase();

          if (aValue < bValue)
            return sortConfig.direction === 'ascending' ? -1 : 1;
          if (aValue > bValue)
            return sortConfig.direction === 'ascending' ? 1 : -1;
          return 0;
        }
      });

      setSortedData(sorted);
    } else {
      setSortedData(containersData);
    }
  }, [containersData, sortConfig]);

  // Get display data
  const getDisplayData = () => {
    return sortConfig.key ? sortedData : containersData;
  };

  // Check if we're in the first table structure (with containers)
  const isFirstTableStructure =
    containersData &&
    containersData.length > 0 &&
    containersData[0]?.containers;

  return (
    <>
      {mptyTrackingEnable === 'nis' ? (
        <div className="mt-16">
          <LoadingV2 />
        </div>
      ) : mptyTrackingEnable === '1' ? (
        <>
          <HintLegend
            hints={[
              {
                letter: 'A',
                label: 'Autobook',
                colorClasses:
                  'text-success-secondary border border-solid border-success-secondary',
              },
              {
                letter: 'M',
                label: 'Manual',
                colorClasses:
                  'text-primary-blue border border-solid border-primary-blue',
              },
              {
                letter: 'E',
                label: 'External',
                colorClasses:
                  'text-inactive-text border border-solid border-inactive-text',
              },
            ]}
          />
          <table ref={tableRef} id="table" className={cls.list}>
            <thead ref={amirbios2Ref} id="amirbios1" className={cls.tableThead}>
              <tr ref={amirbios1Ref} id="amirbios2" className={cls.thead}>
                <th style={{ flex: 0.4 }}>#</th>
                {tableTheadTitle.map((header, index) =>
                  header?.show === false ? (
                    ''
                  ) : (
                    <th
                      key={index}
                      style={{
                        flex: header.flex,
                        minWidth:
                          header.label === 'Return Appointment'
                            ? '268px'
                            : '65px',
                      }}
                      className={
                        sortableColumns[header.object] &&
                        sortConfig.key === sortableColumns[header.object]
                          ? styles.sortableHeaderSorted
                          : sortableColumns[header.object]
                          ? styles.sortableHeader
                          : ''
                      }
                      onClick={
                        sortableColumns[header.object]
                          ? () => sortBy(sortableColumns[header.object])
                          : undefined
                      }>
                      <div
                        className={`flex items-center justify-center ${
                          sortableColumns[header.object]
                            ? 'cursor-pointer'
                            : 'cursor-default'
                        }`}
                        onMouseEnter={() =>
                          sortableColumns[header.object] &&
                          setHoveredColumn(sortableColumns[header.object])
                        }
                        onMouseLeave={() => setHoveredColumn(null)}>
                        <span>{header.label}</span>
                        {sortableColumns[header.object] &&
                          (hoveredColumn === sortableColumns[header.object] ||
                            sortConfig.key ===
                              sortableColumns[header.object]) && (
                            <ReactSVG
                              src={
                                sortConfig.key ===
                                sortableColumns[header.object]
                                  ? sortConfig.key === 'return_appointment'
                                    ? sortConfig.direction === 'ascending'
                                      ? Icons.sortedNewUp
                                      : Icons.sortedNewDown
                                    : sortConfig.direction === 'ascending'
                                    ? Icons.sortedNewUp
                                    : Icons.sortedNewDown
                                  : Icons.sortNew
                              }
                              className={cls.sortIcon}
                            />
                          )}
                      </div>
                    </th>
                  )
                )}
                <th style={{ flex: 1.3 }}>
                  <span className={cls.actionsHeadSpan}>
                    <span>Action</span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody className={cls.tbody}>
              {getDisplayData()?.map((i, idx) =>
                i?.containers?.map((container, idd) => {
                  const timerKey = `timer_${container.id}`;

                  localUniqueIndex++;
                  return (
                    <>
                      <tr
                        className={cls.tableRow}
                        key={`${localUniqueIndex}new`}>
                        <td style={{ flex: 0.4 }}>
                          {localUniqueIndex + (currentPage - 1) * 10}
                        </td>
                        {tableTheadTitle.map((header, index) => {
                          const objectKey = header.object;

                          return header?.show === false ? (
                            ''
                          ) : (
                            <td
                              key={`${index}new`}
                              style={{
                                flex: header.flex,
                                minWidth:
                                  objectKey === 'return_appointment'
                                    ? '268px'
                                    : '38px',
                                width: 'content-fit',
                              }}
                              className="break-words">
                              {['size', 'ssl', 'loc'].includes(objectKey)
                                ? i[objectKey]
                                  ? i[objectKey]
                                  : '-'
                                : ''}
                              {['name'].includes(objectKey) &&
                              header.hasLink ? (
                                <a
                                  className={cls.listHasLink}
                                  href={container['shipping_line_tracking_url']}
                                  onClick={(e) =>
                                    handleContainerNameClick(
                                      e,
                                      container,
                                      objectKey
                                    )
                                  }>
                                  {container[objectKey] || '-'}
                                </a>
                              ) : ['name'].includes(objectKey) ? (
                                container[objectKey] ? (
                                  container[objectKey]
                                ) : (
                                  '-'
                                )
                              ) : (
                                ''
                              )}

                              {[
                                'chases',
                                'return_terminals',
                                'return_dual_terminals',
                              ].includes(objectKey)
                                ? container[objectKey]
                                  ? container[objectKey]
                                  : '-'
                                : ''}
                              {objectKey === 'own_chases'
                                ? container['own_chases'] === 0
                                  ? 'Pool'
                                  : 'Own'
                                : ''}
                              {objectKey === 'return_appointment' ? (
                                container.return_appointment ? (
                                  formatDateTimeToUTC(
                                    container.return_appointment
                                  )
                                ) : enable_appointments === '0' ||
                                  enable_appointments === false ? (
                                  'No Apt. Available'
                                ) : (
                                  <div
                                    className={cls.appointmentDateContainer}
                                    onClick={() =>
                                      Appointment(
                                        i,
                                        container.id,
                                        container.gated_in,
                                        container.gated_out,
                                        container
                                      )
                                    }>
                                    {container?.appointments?.length > 0 ? (
                                      <AppointmentContainer
                                        container={container}
                                        cls={cls}
                                        Appointment={Appointment}
                                        i={i}
                                      />
                                    ) : (
                                      <button
                                        type="button"
                                        className={`${cls.appointmentButton} cursor-pointer bg-white flex items-center justify-center`}>
                                        <div className={cls.svgContainer} />
                                        {container.autobook_on ? (
                                          <>
                                            <ReactSVG
                                              src={Icons.inventoryAptAutobook}
                                              className={cls.appointmentIcon}
                                            />
                                            <span
                                              className={cls.autobookOnText}>
                                              Autobook
                                            </span>
                                          </>
                                        ) : i?.available_appointments_count >
                                          0 ? (
                                          <>
                                            <ReactSVG
                                              src={Icons.inventoryAptBook}
                                              className={cls.appointmentIcon}
                                            />
                                            <span
                                              className={cls.appointmenText}>
                                              Book Now
                                            </span>
                                          </>
                                        ) : (
                                          <>
                                            <ReactSVG
                                              className={cls.appointmentIcon}
                                              src={Icons.inventoryAptNotAvail}
                                            />
                                            <span
                                              className={cls.appointmenText}>
                                              Not Avail.
                                            </span>
                                          </>
                                        )}
                                      </button>
                                    )}
                                  </div>
                                )
                              ) : (
                                ''
                              )}
                              {/* {objectKey === 'gated_out' ? (
                              container.scr_last !== null ||
                              container.gated_in !== null ||
                              container.gated_out !== null ||
                              (timerinterval[timerKey] &&
                                timerinterval[timerKey] > 600) ||
                              container.create_type === 'SYSTEMIC' ? (
                                container.gated_out ? (
                                  formatDateTimeToUTC(container.gated_out)
                                ) : (
                                  '-'
                                )
                              ) : (
                                <svg
                                  width="25"
                                  height="25"
                                  viewBox="0 0 36 36"
                                  className={cls.circularLoader}>
                                  <path
                                    className={cls.circleBackground}
                                    d="M18 2.0845
                              a 15.9155 15.9155 0 0 1 0 31.831
                              a 15.9155 15.9155 0 0 1 0 -31.831"
                                  />
                                  <path
                                    d="M18 2.0845
                              a 15.9155 15.9155 0 0 1 0 31.831
                              a 15.9155 15.9155 0 0 1 0 -31.831"
                                    className={cls.circleFastProgress}
                                    strokeDasharray={`${fastProgress}, 100`}
                                  />
                                  <path
                                    className={cls.circleProgress}
                                    strokeDasharray={`${
                                      timerinterval[timerKey] / 6.2
                                    }, 100`}
                                    d="M18 2.0845
                              a 15.9155 15.9155 0 0 1 0 31.831
                              a 15.9155 15.9155 0 0 1 0 -31.831"
                                  />
                                </svg>
                              )
                            ) : (
                              ''
                            )} */}
                              {objectKey === 'gated_out'
                                ? container['gated_out']
                                  ? formatDateTimeToUTC(container['gated_out'])
                                  : '-'
                                : ''}
                              {objectKey === 'gated_in'
                                ? container['gated_in']
                                  ? formatDateTimeToUTC(container['gated_in'])
                                  : '-'
                                : ''}
                              {objectKey === 'last_free_day'
                                ? container['last_free_day']
                                  ? formatDateToUTC(container['last_free_day'])
                                  : '-'
                                : ''}
                              {objectKey === 'est_per_diem'
                                ? container['est_per_diem']
                                  ? formatPrice(container['est_per_diem'])
                                  : '-'
                                : ''}
                              {objectKey === 'date'
                                ? container['date']
                                  ? formatDateToUTC(container['date'])
                                  : '-'
                                : ''}
                              {objectKey === 'added_date'
                                ? container['added_date']
                                  ? fTimeDateUSFormat(container['added_date'])
                                  : '-'
                                : ''}
                              {objectKey === 'last_update'
                                ? container['updated_at']
                                  ? fTimeDateUSFormat(container['updated_at'])
                                  : '-'
                                : ''}
                            </td>
                          );
                        })}

                        <td className={cls.tabActions} style={{ flex: 1.3 }}>
                          {shareLink.loading === i.id ? (
                            <CircularProgress size={20} />
                          ) : (
                            <IconButtonV2
                              noBorder
                              icon="share"
                              aria-label="share"
                              title="Share"
                              disabled={container.status === 0}
                              onClick={() => handleGetShareLink(container.id)}
                            />
                          )}

                          <IconButtonV2
                            noBorder
                            icon="pen"
                            aria-label="edit"
                            title="Edit"
                            onClick={() =>
                              Edit(
                                i,
                                container.id,
                                container.gated_in,
                                container.gated_out,
                                container
                              )
                            }
                          />

                          <Tooltip
                            arrow
                            placement="top"
                            tooltipId={`container-status-${container.id}`}
                            iconId={`container-status-icon-${container.id}`}
                            title={
                              container.status_message
                                ? container.status_message
                                : container.status === 1
                                ? 'Disable'
                                : 'Enable'
                            }>
                            <IconButtonV2 noBorder>
                              <CustomCheckbox
                                size="small"
                                disabled={
                                  container.status_message ===
                                  'Container in Street Turn Progress'
                                    ? true
                                    : container.status_message ===
                                      'Container is currently Gated In'
                                    ? true
                                    : false
                                }
                                checked={container.status === 1}
                                color="black"
                                onChange={(e) =>
                                  handleChangeContainerStatus(
                                    e.target.checked,
                                    container.id,
                                    idd
                                  )
                                }
                              />
                            </IconButtonV2>
                          </Tooltip>

                          <IconButtonV2
                            noBorder
                            icon="deleteIcon"
                            aria-label="delete"
                            title="Delete"
                            onClick={() =>
                              handleDeleteClick(container.id, 'container')
                            }
                          />
                        </td>
                      </tr>
                    </>
                  );
                })
              )}
            </tbody>
          </table>
        </>
      ) : !mptyTrackingEnable ||
        mptyTrackingEnable === '0' ||
        mptyTrackingEnable === undefined ? (
        <>
          <HintLegend
            hints={[
              {
                letter: 'A',
                label: 'Autobook',
                colorClasses:
                  'text-success-secondary border border-solid border-success-secondary',
              },
              {
                letter: 'M',
                label: 'Manual',
                colorClasses:
                  'text-primary-blue border border-solid border-primary-blue',
              },
              {
                letter: 'E',
                label: 'External',
                colorClasses:
                  'text-inactive-text border border-solid border-inactive-text',
              },
            ]}
          />
          <table className={cls.list}>
            <thead className={cls.thead}>
              <th style={{ flex: 0.35 }}>#</th>
              <th
                style={{ flex: 1 }}
                className={
                  sortConfig.key === 'size'
                    ? styles.sortableHeaderSorted
                    : styles.sortableHeader
                }
                onClick={() => sortBy('size')}>
                <div
                  className="flex items-center cursor-pointer justify-center"
                  onMouseEnter={() => setHoveredColumn('size')}
                  onMouseLeave={() => setHoveredColumn(null)}>
                  <span>Size</span>
                  {(hoveredColumn === 'size' || sortConfig.key === 'size') && (
                    <ReactSVG
                      src={
                        sortConfig.key === 'size'
                          ? sortConfig.direction === 'ascending'
                            ? Icons.sortedNewUp
                            : Icons.sortedNewDown
                          : Icons.sortNew
                      }
                      className={cls.sortIcon}
                    />
                  )}
                </div>
              </th>
              <th
                style={{ flex: 0.7 }}
                className={
                  sortConfig.key === 'ssl'
                    ? styles.sortableHeaderSorted
                    : styles.sortableHeader
                }
                onClick={() => sortBy('ssl')}>
                <div
                  className="flex items-center cursor-pointer justify-center"
                  onMouseEnter={() => setHoveredColumn('ssl')}
                  onMouseLeave={() => setHoveredColumn(null)}>
                  <span>SSL</span>
                  {(hoveredColumn === 'ssl' || sortConfig.key === 'ssl') && (
                    <ReactSVG
                      src={
                        sortConfig.key === 'ssl'
                          ? sortConfig.direction === 'ascending'
                            ? Icons.sortedNewUp
                            : Icons.sortedNewDown
                          : Icons.sortNew
                      }
                      className={cls.sortIcon}
                    />
                  )}
                </div>
              </th>
              <th style={{ flex: 0.7 }}>Active</th>
              <th style={{ flex: 0.7 }}>Container #</th>
              <th
                style={{ flex: 1.2 }}
                className={
                  sortConfig.key === 'loc'
                    ? styles.sortableHeaderSorted
                    : styles.sortableHeader
                }
                onClick={() => sortBy('loc')}>
                <div
                  className="flex items-center cursor-pointer justify-center"
                  onMouseEnter={() => setHoveredColumn('loc')}
                  onMouseLeave={() => setHoveredColumn(null)}>
                  <span>Location</span>
                  {(hoveredColumn === 'loc' || sortConfig.key === 'loc') && (
                    <ReactSVG
                      src={
                        sortConfig.key === 'loc'
                          ? sortConfig.direction === 'ascending'
                            ? Icons.sortedNewUp
                            : Icons.sortedNewDown
                          : Icons.sortNew
                      }
                      className={cls.sortIcon}
                    />
                  )}
                </div>
              </th>
              <th style={{ flex: 1 }}>Available Date</th>
              <th style={{ flex: 0.7 }}>Number of Own Chassis</th>
              <th style={{ flex: 0.7 }}>Number of Pool Chassis</th>
              <th
                style={{ flex: 1 }}
                className={
                  sortConfig.key === 'updated_at'
                    ? styles.sortableHeaderSorted
                    : styles.sortableHeader
                }
                onClick={() => sortBy('updated_at')}>
                <div
                  className="flex items-center cursor-pointer justify-center"
                  onMouseEnter={() => setHoveredColumn('updated_at')}
                  onMouseLeave={() => setHoveredColumn(null)}>
                  <span>Last Update</span>
                  {(hoveredColumn === 'updated_at' ||
                    sortConfig.key === 'updated_at') && (
                    <ReactSVG
                      src={
                        sortConfig.key === 'updated_at'
                          ? sortConfig.direction === 'ascending'
                            ? Icons.sortedNewUp
                            : Icons.sortedNewDown
                          : Icons.sortNew
                      }
                      className={cls.sortIcon}
                    />
                  )}
                </div>
              </th>
              <th style={{ flex: 1 }}>
                <span className={cls.actionsHeadSpan}>
                  <span>Action</span>
                </span>
              </th>
            </thead>
            <tbody className={cls.tbody}>
              {getDisplayData().map((i, idx) => (
                <tr className={cls.tableRow} key={idx}>
                  <td style={{ flex: 0.35 }}>
                    {idx + 1 + (currentPage - 1) * 10}
                  </td>
                  <td style={{ flex: 1 }}>{i.size}</td>
                  <td className="break-words" style={{ flex: 0.7 }}>
                    {i.ssl}
                  </td>
                  <td style={{ flex: 0.7 }}>{i.count_all}</td>
                  <td style={{ flex: 0.7 }}>{i.active}</td>
                  <td style={{ flex: 1.2 }}>{i.loc}</td>
                  <td style={{ flex: 1 }}>{fDate(i.date)}</td>
                  <td style={{ flex: 0.7 }}>{i.own_chases_count}</td>
                  <td style={{ flex: 0.7 }}>{i.pool_chases_count}</td>
                  <td style={{ flex: 1 }}>{fTimeDateUSFormat(i.updated_at)}</td>
                  <td className={cls.tabActions} style={{ flex: 1 }}>
                    {shareLink.loading === i.id ? (
                      <CircularProgress size={20} />
                    ) : (
                      <IconButtonV2
                        noBorder
                        icon="share"
                        title="Share"
                        aria-label="share"
                        disabled={i.active === 0}
                        onClick={() => handleGetShareLink(i)}
                      />
                    )}

                    <IconButtonV2
                      noBorder
                      icon="pen"
                      aria-label="edit"
                      title="Edit"
                      onClick={() => Edit(i)}
                    />

                    <IconButtonV2
                      noBorder
                      icon="container"
                      title="Containers"
                      onClick={() => {
                        setShowContainersModal(!showContainersModal);
                        setSelectedRow(i);
                      }}>
                      {/* <img src={getActivContainers(i)} /> */}
                      {getActivContainers(i)}
                    </IconButtonV2>

                    <IconButtonV2
                      noBorder
                      icon="deleteIcon"
                      aria-label="deleteIcon"
                      title="Delete"
                      onClick={() => handleDeleteClick(i.id, 'inventory')}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      ) : (
        <div className="mt-16">
          <LoadingV2 />
        </div>
      )}

      {/* Delete Confirmation Modal */}
      <Modal
        minWidth="unset"
        noX
        show={showDeleteModal.show}
        children={
          <span className="mt-6 text-center w-full md:min-w-xl">
            Are you sure you want to delete this{' '}
            {showDeleteModal.deleteType === 'container'
              ? 'container'
              : 'inventory item'}
            ?
          </span>
        }
        submitText={'Yes, Delete'}
        icon={'deleteIcon'}
        title={`Delete ${
          showDeleteModal.deleteType === 'container'
            ? 'Container'
            : 'Inventory Item'
        }`}
        setShow={(value) => {
          setShowDeleteModal({
            show: value,
            itemId: showDeleteModal.itemId,
            deleteType: showDeleteModal.deleteType,
          });
        }}
        submit={handleDeleteConfirm}
        loadingbutton={false}
      />
    </>
  );
};

export default TableDroppedList;
